import { autoserializeAs, autoserializeAsArray } from 'dcerialize';
import { RestItemList } from './rest-item';

/**
 * User CRUD class
 */
export class User {
  /**
   * ID
   */
  @autoserializeAs(() => Number) _id!: number;

  /**
   * User name
   */
  @autoserializeAs(() => String) name: string;

  /**
   * User email
   */
  @autoserializeAs(() => String) email: string;

  /**
   * Roles
   */
  @autoserializeAsArray(() => String) roles: string[];

  /**
   * Enabled
   */
  @autoserializeAs(() => Boolean) enabled?: boolean;

  /**
   * Deleted
   */
  @autoserializeAs(() => Boolean) deleted?: boolean;


  constructor(name = '', email = '', roles = []) {
    this.name = name;
    this.email = email;
    this.roles = roles;
  }

  /**
   * User role checker
   * @param {string} role Name of the role to check
   * @return {boolean} Whether the user has the role or not
   */
  public hasPermission(role: string): boolean {
    return this.roles.includes(role);
  }
}

/**
 * Class that represents a user list response
 */
export class UserList extends RestItemList<User> {
  /**
   * User list
   */
  @autoserializeAsArray(() => User) items: User[];

  /**
   * Number of entries in list
   */
  @autoserializeAs(() => Number) total: number;

  constructor(items: User[] = [], total = 0) {
    super();
    this.items = items;
    this.total = total;
  }
}

/**
 * Class to change user password
 */
export class UserPassword {
  /**
   * new password
   */
  @autoserializeAs(() => String, 'password') newPassword: string;
  /**
   * Confirm new Password
   */
  @autoserializeAs(() => String, 'repeat_password') repeatPassword: string;

  constructor(newPassword: string, repeatPassword: string) {
    this.newPassword = newPassword;
    this.repeatPassword = repeatPassword;
  }
}
/**
 * User data to check password
 */
export class UserDataToCheckPassword {
  /**
   * Full name
   */
  @autoserializeAs(() => String) name: string;
  /**
   * Username
   */
  @autoserializeAs(() => String) username: string;

  /**
   * email
   */
  @autoserializeAs(() => String) email: string;
  /**
   * password
   */
  @autoserializeAs(() => String) password: string;

  constructor(name = '', username = '', email = '', password = '') {
    this.name = name;
    this.username = username;
    this.email = email;
    this.password = password;
  }
}
/**
 * User password score
 */
export class UserPasswordScore {
  /**
   * score
   */
  @autoserializeAs(() => Number) score: number;
  constructor(score: number) {
    this.score = score;
  }
}

/**
 * User password and token
 */
export class UserPasswordAndToken {
  /**
   * password
   */
  @autoserializeAs(() => String) password: string;

  /**
   * Token
   */
  @autoserializeAs(() => String) token: string;

  constructor(password: string, token: string) {
    this.password = password;
    this.token = token;
  }
}

export class UserImpersonateToken {
  /**
   * Token
   */
  @autoserializeAs(() => String) token: string;

  @autoserializeAs(() => String) backofficeRedirectUrl: string;

  constructor(token: string, backofficeRedirectUrl: string) {
    this.token = token;
    this.backofficeRedirectUrl = backofficeRedirectUrl;
  }
}

export class RegisterUserList {
  /**
   * User emails
   */
  @autoserializeAsArray(() => String) email: string[];

  /**
   * User roles
   */
  @autoserializeAsArray(() => String) roles: string[];

  constructor(email: string[], roles: string[]) {
    this.email = email;
    this.roles = roles;
  }
}
